import { render, staticRenderFns } from "./IssueView.vue?vue&type=template&id=b72b6816&scoped=true&"
import script from "./IssueView.vue?vue&type=script&lang=js&"
export * from "./IssueView.vue?vue&type=script&lang=js&"
import style0 from "./IssueView.vue?vue&type=style&index=0&id=b72b6816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72b6816",
  null
  
)

export default component.exports